import styled from '@emotion/styled';

export const LinkWrapper = styled.div`
  position: absolute;
  display: block;
`;
